import { useMutation } from "@tanstack/react-query";
import { unitPdfUpdate } from "common/api/citajteo/dl_unit/dl_unit_edit";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseUnitPdfUpdateParams = {
  invalidateKeys?: string[];
  successHandle?: Function;
  errorHandle?: Function;
};

export const useUnitPdfUpdate = (hookParams?: UseUnitPdfUpdateParams) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: unitPdfUpdateMutate } = useMutation({
    mutationFn: async (params: { unitId: string; fileName: string }) => {
      const response = await unitPdfUpdate(params.unitId, params.fileName);

      if (!response) {
        throw new Error("unitPdfUpdate failed");
      }

      return response;
    },
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }

      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
    onError: (error) => {
      if (hookParams?.errorHandle) {
        hookParams.errorHandle(error);
      }
    },
  });

  return { unitPdfUpdateMutate };
};
